import React from 'react';
import { GlitchText } from './GlitchText';

export const Hero: React.FC = () => {
  return (
    <div className="relative z-10 text-center max-w-full overflow-x-hidden">
      <h1 className="text-4xl md:text-6xl font-bold mb-4">
        <GlitchText text="FWOOZIE" className="text-white" />
      </h1>

      <p className="text-lg md:text-xl text-gray-300 mb-6">
        The future is now
      </p>

      {/*
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <button
            onClick={() => scrollToSection('chatbot')}
            className="px-6 py-2.5 bg-primary text-dark font-semibold rounded-lg hover:bg-primary-dark transition-all duration-300 shadow-lg hover:shadow-primary/50"
          >
            Try the Chatbot
          </button>

          <button
            onClick={() => scrollToSection('about')}
            className="px-6 py-2.5 bg-transparent border-2 border-primary text-primary font-semibold rounded-lg hover:bg-primary/10 transition-all duration-300"
          >
            Learn More
          </button>
        </div>
      */}
    </div>
  );
};
